import TemplateView from '../../../TemplateView'
import messageResource from '../../../messageResource'
import {GROUP_NEW_OR_NOT_KNOWN, ValidationErrors} from '../constants'
import AccountInformationSection from '../../../administration/userManagement/AccountInformationSection'
import {escapeHtmlSymbols, trim} from '../../../atUtils'
import {UserManagementConstants, USERS_WITHOUT_GROUP_ID} from 'constants'
import SimpleListMenuButton from '../../../SimpleListMenuButton'
import _ from 'underscore'
import {isEnterPressed, isEscapePressed} from '../../../atBrowserUtils'

export default class UserGroupRow extends TemplateView {
    constructor({
        showSaveButton = true,
        createNewUserGroup = () => {},
        updateRowDate = () => {},
        onGroupChanged = (id) => {},
        resetGroup = () => {},
    }) {
        super()

        this.params = {
            showSaveButton,
            createNewUserGroup,
            onGroupChanged,
            resetGroup,
            updateRowDate,
        }

        this.state = {
            groupId: USERS_WITHOUT_GROUP_ID,
            userGroups: [],
            newGroupCreating: false,
            editable: false,
            errors: {},
        }

        this.selector = null
        this.enableCreateButton = false

        this.onAnyStatePropertyDeeplyChanged(['userGroups', 'groupId', 'editable'], () => {
            this.$selector.empty()
            this.$selectorContainer.toggle(this.state.editable)
            this.$departmentLabel.toggle(!this.state.editable)

            if (this.state.editable)
                this.selector = this._createSelector(this.state.userGroups, this.state.groupId, this.$selector)
        })

        this.onStatePropertyBecameValue('newGroupCreating', false, () => {
            this.$newGroupInput.val("")
        })

        this.onAnyStatePropertyChanged(['groupId', 'newGroupCreating'], () => {
            const id = this.state.groupId
            const creating = this.state.newGroupCreating
            this._setSelectedUserGroup(this.state.newGroupCreating ? GROUP_NEW_OR_NOT_KNOWN : this.state.groupId)

            this.$newGroupSection.toggle(creating)
            
            //no need to disable the Create button in the newGroupCreating mode if the required fields for creating a new group are filled
            if (!id || creating && _.isEmpty(trim(this.$newGroupInput.pVal()))) {
                this._handleEnableCreateButton(false)
            }
        })

        this.onStatePropertyChanged('errors', (errors) => {
            const showEmptyError = !!errors[ValidationErrors.NEW_USER_GROUP_EMPTY]
            this.$userGroupNameError.toggle(showEmptyError)
            this.$newGroupInput.toggleClass('invalid', showEmptyError)

            if (showEmptyError)
                this._handleEnableCreateButton(false)
        })
    }

    templateHtml() {
        return "<div class='userGroupRow_userPanel'>" +
               "  <div class='cellLabel'>" +
               "     <div class='label'>" +
               "       <%-label%>" +
               "     </div>:" +
               "  </div>" +
               "  <div class='selector'>" +
               "    <div class='selectorPlaceholder'/>" +
               "  </div>" +
               "  <div class='departmentLabel'></div>" +
               "  <div class='newGroupSection'>" +
               "    <input type='text' class='newGroupInput' name='newUserGroupName' maxlength='40'>" +
               "    <div class='userGroupNameError'><%-empty_error%></div>" +
               "    <div class='buttons'>" +
               "      <div class='saveButton'><%-save%></div>" +
               "      <div class='cancelButton'><%-cancel%></div>" +
               "    </div>" +
               "  </div>" +
               "</div>"
    }

    templateModel() {
        return {
            label: messageResource.getMessage('userlist.userdata.account_section.user_group'),
            empty_error: messageResource.getMessage('user.add_edit.error.name_empty'),
            save: messageResource.getMessage('common.create'),
            cancel: messageResource.getMessage('common.cancel'),
        }
    }


    afterRender() {
        this.$selector = this.find(".selectorPlaceholder")
        this.$selectorContainer = this.find(".selector")
        this.$departmentLabel = this.find(".departmentLabel")
        this.$newGroupSection = this.find(".newGroupSection")
        this.$newGroupInput = this.find(".newGroupInput")
        this.$userGroupNameError = this.find('.userGroupNameError')

        if (this.params.showSaveButton) {
            this.$saveButton = this.find(".saveButton")
            this.$saveButton.click(() => {
                if (this.enableCreateButton) {
                    const name = trim(this.$newGroupInput.pVal())
                    this.params.updateRowDate({
                        newGroupCreating: false,
                    })
                    this.params.createNewUserGroup(name)
                }
            })

            this.find(".cancelButton").click(() => {
                this.params.updateRowDate({
                    newGroupCreating: false,
                })

                this.params.resetGroup()
            })
        } else {
            this.find(".buttons").hide()
        }

        this.$newGroupInput.valueChanged(() => {
            this._onNewGroupChangeHandler()
        })

        this.$newGroupInput.keydown(this._handleNewGroupInputKeyDown)

        this.$newGroupInput.attr("placeholder", messageResource.getMessage("user.add.js.user_group_selector.new_user_group_place_holder")).placeholder()

        this.renderInitialState()
    }

    _onNewGroupChangeHandler() {
        const name = trim(this.$newGroupInput.pVal())
        if (this.params.showSaveButton) {
            this._handleEnableCreateButton(!!name)
        }
        else {
            this.params.createNewUserGroup(name)
        }
    }

    _handleEnableCreateButton(enable) {
        if (this.params.showSaveButton) {
            this.enableCreateButton = enable
            this.$saveButton.toggleClass('disabled', !enable)
        }
    }

    _createSelector(userGroups, selectedGroupId, renderTo) {
        const userGroupNotAssignedGroup = this._createNotAssignedUserGroup()

        const newUserGroupGroup = this._createNewGroupOrNotKnow()
        const listItems = [userGroupNotAssignedGroup, newUserGroupGroup].concat(userGroups ? userGroups : [])

        const escapedListItems = listItems.map((item) => ({id: item.id, name: escapeHtmlSymbols(item.name)}))

        let selector = new SimpleListMenuButton({
            extraClass: 'components_userGroupSelectorMenu',
            itemHtmlCallback: item => item.name,
            onSelect: (item) => {
                this.params.updateRowDate({
                    newGroupCreating: item.id === GROUP_NEW_OR_NOT_KNOWN,
                    groupId: item.id,
                })
                if (item.id !== GROUP_NEW_OR_NOT_KNOWN) {
                    this.params.onGroupChanged(item.id)
                }
            },
            itemHeight: 30,
        }).init(renderTo)

        const selectedItem = escapedListItems.find(item => item.id === selectedGroupId)
        selector.setItems(escapedListItems, selectedItem || escapedListItems[0])

        return selector
    }

    _createNotAssignedUserGroup() {
        return {
            name: messageResource.getMessage("user.add.js.user_group_selector.user_group_not_selected_item_title"),
            id: UserManagementConstants.USER_GROUP_NOT_ASSIGNED_ID,
        }
    }

    _createNewGroupOrNotKnow() {
        return {
            name: messageResource.getMessage("user.add.js.user_group_selector.new_user_group_item_title"),
            id: AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN,
        }
    }

    _setSelectedUserGroup(id) {
        if (this.state.editable)
            this._setSelectorItem(id)
        else
            this._setSelectedUserGroupLabel(id)
    }

    _setSelectorItem(id) {
        let item
        if (id === USERS_WITHOUT_GROUP_ID) {
            item = this._createNotAssignedUserGroup()
        }
        else if (id === GROUP_NEW_OR_NOT_KNOWN) {
            item = this._createNewGroupOrNotKnow()
        }
        else {
            item = this.state.userGroups.find(item => item.id === id)
        }
        if (item) {
            this.selector.setSelectedItem({id: item.id, name: escapeHtmlSymbols(item.name)})
        }
    }

    _setSelectedUserGroupLabel(id) {
        let groupName = ''
        if (id === USERS_WITHOUT_GROUP_ID) {
            groupName = messageResource.getMessage('user.js.user_group_selector.group_not_selected_label')
        } else {
            const userGroup = this.state.userGroups.find(item => item.id === id)
            if (!!userGroup)
                groupName = userGroup.name
        }
        this.$departmentLabel.text(groupName)
    }

    _handleNewGroupInputKeyDown = (e) => {
        if (isEscapePressed(e) || isEnterPressed(e)) {
            this.$newGroupInput.blur()
            e.stopPropagation()
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/components/UserGroupRow.js